/**
 * Created by fers on 01.07.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import Error from '../box/system/Error.react.js';
import CachingRequired from '../box/system/CachingRequired.react';
import {sendError} from '../../app/errorDisplayer';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import {injectIntl} from 'react-intl';

import handlers from './../box/handlers';

export function getHandler(viewWithData) {
    let handlerClass;
    let view = viewWithData.view;

    let handlerName;
    if (view.entityViewDef) {
        handlerName = view.entityViewDef.handler;
    }

    if (!handlerName) {
        handlerName = view.handler;
    }

    if (!handlerName) {
        handlerName = 'json-table';
    }

    let handler = handlers[handlerName];

    if (handler) {
        handlerClass = handler.handler;

        return handlerClass;
    }

    return null;
}

class BoxDisplayer extends React.Component {

    static propTypes = {
        intl: PropTypes.object,
        isPreview: PropTypes.bool,
        relay: PropTypes.object,
        viewWithData: PropTypes.object.isRequired,
    };

    static defaultProps = {
        isPreview: false,
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        let viewWithData = this.props.viewWithData;

        if (viewWithData.cachingRequired) {
            return (
                <CachingRequired viewWithData={viewWithData} />
            );
        } else if (!('error' in viewWithData) || viewWithData.error === false) {
            try {
                let handler = getHandler(viewWithData);

                if (!handler) {
                    return null;
                }

                return (
                    React.createElement(handler, {
                        viewWithData: viewWithData,
                        intl: this.props.intl,
                        relay: this.props.relay,
                        isPreview: this.props.isPreview
                    })
                );
            } catch (e) {
                sendError(e);
            }
        }

        console.log("View", viewWithData.view ? viewWithData.view['id'] : '<no id>', "has error in data", viewWithData); // eslint-disable-line no-console

        return (
            <Error viewWithData={viewWithData} />
        );
    }
}

export default injectIntl(BoxDisplayer);
